export function EmailBodyPreview({ html }: { html: string }) {
  return (
    <iframe
      title="Email content preview"
      // Match the campaign template preview: no scripts, same-origin access,
      // popups, forms, or top-level navigation from stored email HTML.
      sandbox=""
      srcDoc={html}
      className="h-[400px] w-full rounded-md border border-border bg-white"
    />
  );
}
